// extracted by mini-css-extract-plugin
module.exports = {"progress":"ProgressInfo_progress__3m_C3","indeterminateAnimation":"ProgressInfo_indeterminateAnimation__1nj4d"};